import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ErrorMessages from '../../../SharedModule/MessageHandlers/ErrorMessages';
import SuccessMessage from '../../../SharedModule/MessageHandlers/SuccessMessage';
import Spinner from '../../../SharedModule/Spinner/Spinner';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import * as serviceEndPoint from '../../../SharedModule/Service/service';
import axios from 'axios';
import { ValidateOtpCode, ValidateOtpCount, ValidateOtpResponse, ResetOtpCount, GenerateOtpResponse } from '../Store/Actions/MFACodeActions'
import { SYSTEM_ERROR } from '../../../SharedModule/Utils/AppConstants'
// import Captcha from '../../Login/Components/Captcha';
import { LoginUserActions, resetLoginData } from '../../Login/Store/Actions/LoginActions';
import {  EventsLogActions, resetLogoutData, LogoutActions, } from '../../../SharedModule/Store/Actions/AppActions';
import * as LoginConstants from '../../Login/Components/LoginConstants';
import moment from 'moment';

const ValidateOtp = (props) => {
    const dispatch = useDispatch();
    const logoutDispatch = (logoutCriteria) => dispatch(LogoutActions(logoutCriteria));
    const captcha = React.createRef();
    const otpResponse = useSelector(state => state.mfaCodeReducers.otpResponse);
    const loginUserData = useSelector(state => state.loginState.loginUser);
    const logoutData = useSelector(state => state.sharedState.logout);
    // const otpResponse = props.location.state && props.location.state.otpResponse
    const passwordExpiry = props.location.state && props.location.state.passwordExpiry
    const passwordExpiryRem = props.location.state && props.location.state.passwordExpiryRem
    const isMFAData = props.location.state && props.location.state.isMFA
    const mfaType = props.location.state && props.location.state.mfaType
    const userIdForResend = props.location.state && props.location.state.userId
    
    let errorMessagesArray = [];
    useEffect(() => {
        if (!isMFAData) {
            AppConstants.backToLogin(props);
        }
    }, [isMFAData])
    const validateOtpRes = useSelector(state => state.mfaCodeReducers.validateOtpResponse)
    const validateOtpCnt = useSelector(state => state.mfaCodeReducers.validateOtpCount)
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [successMessages, setSuccessMessages] = React.useState([]);
    const [spinnerLoader, setSpinnerLoader] = React.useState(false);
    const [openToken, setOpenToken] = React.useState(false);
    const [revokeToken, setRevokeToken] = React.useState(false);
    const [openReminder, setOpenReminder] = React.useState(false);
    const [reminderDays, setReminderDays] = React.useState(0);
    const [authToken, setAuthToken] = React.useState('');
    const [accountLocked, setAccountLocked] = React.useState(false);
    // const [passwordExpiry, setPasswordExpiry] = React.useState('');
    // const [passwordExpiryRem, setPasswordExpiryRem] = React.useState('');
    const [openExpired, setOpenExpired] = React.useState(false);
    
    const [otp, setOtp] = React.useState('');
    const [isValidatedOTP, setIsValidatedOTP] = React.useState(false);
    const [isCodeGenerated, setIsCodeGenerated] = React.useState(false);
    // const isAuthorisedUser = sessionStorage.getItem('authToken');

    // useEffect(() => {
    //     if (!isAuthorisedUser) {
    //         AppConstants.backToLogin(props);
    //     }
    // }, []);
    useEffect(() => {
        if (validateOtpCnt === 3) {
            const input = { 'userId': otpResponse && otpResponse.userId }
            axios.post(`${serviceEndPoint.LOCK_ACCOUNT}`, input)
                .then(response => {
                    //   dispatch(ValidateOtpResponse(response.data));
                    setErrorMessages([LoginConstants.PASSWORD_LONG_EXPIRED_ERROR])
                    setSpinnerLoader(false);
                    setAccountLocked(true);
                    setOtp('')
                })
                .catch(error => {
                    //   dispatch(ValidateOtpResponse({ systemFailure: true }));
                    setErrorMessages([SYSTEM_ERROR])
                    setSpinnerLoader(false)
                    setOtp('')
                });
        }

    }, [validateOtpCnt])

    useEffect(() => {
        if (otpResponse && otpResponse.status === 'Generated' && isCodeGenerated) {
          setSpinnerLoader(false)
          setErrorMessages([])
          setSuccessMessages(['OTP has been resent successfully.'])
          
        }
        else if (otpResponse && (otpResponse.status === 'Technical Error'
          || otpResponse.status === 'Bad Request' || otpResponse.status === 'Failure'
          || otpResponse.systemFailure)) {
          // setErrorMessages(['We could not send otp. please try again after sometime.'])
          setErrorMessages([SYSTEM_ERROR])
          setSpinnerLoader(false)
        }
      }, [otpResponse, isCodeGenerated])
    

    /*
    useEffect(() => {
       
        if (validateOtpRes && validateOtpRes.status === 'Success') {
            console.log('inside validate otp useEffect redirect to claims: ', validateOtpRes)
            // setSuccessMessages([validateOtpRes.message])
            setSpinnerLoader(false)
            redirectToClaims();
        }
        else if (validateOtpRes && validateOtpRes.status === 'Failed') {
            dispatch(ValidateOtpCount())
            // setErrorMessages([validateOtpRes.message])
            setErrorMessages(['The verification code you entered is incorrect.'])
            setSpinnerLoader(false)
            setOtp('')
        }
        else if (validateOtpRes && (validateOtpRes.status === 'Technical Error' || validateOtpRes.systemFailure)) {
            setErrorMessages([SYSTEM_ERROR])
            setSpinnerLoader(false)
            setOtp('')
        }
    }, [validateOtpRes])
    */

    // method to handle onchange of checkbox
    const handleChanges = (e) => {
        setSuccessMessages([])
        setErrorMessages([])
        setOtp(e.target.value)
    }

    useEffect(() => {
        if (loginUserData && isValidatedOTP && validateOtpRes) {
            setOpenReminder(false);
            setOpenExpired(false);
            setOpenToken(false);
            setReminderDays(0);
            setSpinnerLoader(false);
            errorMessagesArray = [];
            setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(loginUserData, errorMessagesArray, LoginConstants.LOGIN_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                systemFailure();
            } else if (loginUserData.accessToken) {
                setAuthToken(loginUserData.accessToken);
                sessionStorage.setItem('authToken', loginUserData.accessToken);
                let pwdChangeDiff = 0;
                if (loginUserData.pwdLastChanged) {
                    pwdChangeDiff = checkPasswordExpiry(loginUserData.pwdLastChanged);
                }

                if (pwdChangeDiff > +passwordExpiryRem &&
                    pwdChangeDiff <= +passwordExpiry) {
                    // open popup, Yes --> chng pwd, No--> Claims
                    setOpenReminder(true);
                    setOpenExpired(false);
                    setOpenToken(false);
                    checkReminderDays(loginUserData.pwdLastChanged);
                }
                else if (pwdChangeDiff > +passwordExpiry &&
                    pwdChangeDiff <= (+passwordExpiryRem + +passwordExpiry)) {
                    // open popup, OK --> Chnge Pwd, Log evnt
                    const eventLog = {
                        memberId: "",
                        createdBy: props.userID,
                        eventSource: "Login",
                        eventType: "The password has expired",
                        eventDescription: `${props.userID} attempted to log in with expired password.`
                    }
                    dispatch(EventsLogActions(eventLog));
                    setOpenReminder(false);
                    setOpenExpired(true);
                    setOpenToken(false);
                } 
                 else {
                    if (loginUserData.tokenStatus === AppConstants.SUCCESS) {
                        if (loginUserData.passwordChange === true || loginUserData.passwordChange === 'true') {
                            redirectToCP();
                        } else if (loginUserData.passwordChange === false || loginUserData.passwordChange === 'false') {
                            redirectToClaims();
                            
                            
                        } else {
                            if (!errorMessagesArray || (errorMessagesArray && errorMessagesArray.length === 0)) {
                                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                            }
                            systemFailure();
                        }
                    } else {
                        setOpenReminder(false);
                        setOpenExpired(false);
                        setOpenToken(true);
                    }
                }
            } else {
                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                systemFailure();
            }
        }
    }, [loginUserData, isValidatedOTP, validateOtpRes]);


        useEffect(() => {
            if (logoutData) {
                errorMessagesArray = [];
                setErrorMessages([]);
                errorMessagesArray = AppConstants.handleAPIErrors(logoutData, errorMessagesArray, AppConstants.SYSTEM_ERROR);
                if (errorMessagesArray && errorMessagesArray.length > 0) {
                    systemFailure();
                } else if (logoutData.status === AppConstants.SUCCESS) {
                    dispatch(resetLogoutData('logout'));
                    if (revokeToken) {
                        const eventLog = {
                            memberId: "",
                            createdBy: otpResponse.userId && otpResponse.userId,
                            eventSource: "Login",
                            eventType: "Failed",
                            eventDescription: `The login attempt by user ${otpResponse.userId && otpResponse.userId} has terminated the existing remote session.`
                        }
                        dispatch(EventsLogActions(eventLog));
                        if (loginUserData.passwordChange === true || loginUserData.passwordChange === 'true') {
                            redirectToCP();
                        } else if (loginUserData.passwordChange === false || loginUserData.passwordChange === 'false') {
                            redirectToClaims();
                        } else {
                            if (!errorMessagesArray || (errorMessagesArray && errorMessagesArray.length === 0)) {
                                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                            }
                            systemFailure();
                        }
                    } else {
                        dispatch(resetLoginData('loginUser'));
                        dispatch(resetLogoutData('appConfigDropdown'));
                        sessionStorage.removeItem('authToken');
                        AppConstants.backToLogin(props);
                        // props.setShowPassword(false);
                        // props.setValues({
                        //     userId: ''
                        // })
                        // setValues({
                        //     password: ''
                        // })
                    }
                } else {
                    errorMessagesArray.push(AppConstants.SYSTEM_ERROR);
                    systemFailure();
                }
            }
        }, [logoutData]);


    // Method to check if Password has expired
    const checkPasswordExpiry = (pwdLastChanged) => {
        const char = "T";
        const position = 8;
        const pwdChangedDate = moment([pwdLastChanged.slice(0, position), char, pwdLastChanged.slice(position)].join(''));

        const today = moment(new Date());
        const diff = today.diff(pwdChangedDate, 'days');

        return diff;
    }

    // Method to calculate the remaining days for password Expiry
    const checkReminderDays = (pwdLastChanged) => {
        const char = "T";
        const position = 8;
        const pwdChangedDate = moment([pwdLastChanged.slice(0, position), char, pwdLastChanged.slice(position)].join(''));

        const expiryRemDate = moment(pwdChangedDate, "DD-MM-YYYY").add(+passwordExpiry + 1, 'days');

        const today = moment(new Date());
        const diff = expiryRemDate.diff(today, 'days');

        setReminderDays(diff);
    }


    // Method to set system failure values
    const systemFailure = () => {
        if (errorMessagesArray[0].indexOf(LoginConstants.LOGIN_TECHNICAL_ERROR) > -1) {
            let statusCode = '';
            if (loginUserData.systemFailure) {
                statusCode = 500;
            }
            else {
                statusCode = loginUserData.status ? loginUserData.status : 500;
            }
            const eventLog = {
                memberId: "",
                createdBy: otpResponse.userId && otpResponse.userId,
                eventSource: "Login",
                eventType: "Failed",
                eventDescription: `Login attempt by Member ${otpResponse.userId && otpResponse.userId} failed because of status code ${statusCode}.`
            }
            dispatch(EventsLogActions(eventLog));
        }
        dispatch(resetLoginData('loginUser'));
        dispatch(resetLogoutData('logout'));
        dispatch(resetLogoutData('appConfigDropdown'));
        setErrorMessages(errorMessagesArray);
        sessionStorage.removeItem('authToken');
    }

    // Method to handle revoke previous session
    const handleRevoke = () => {
        setRevokeToken(true);
        setOpenToken(false);
        const logoutRequest = {
            logoutType: "Revoke",
            userId: otpResponse.userId ? otpResponse.userId : ''
        }
        logoutDispatch(logoutRequest);
    }

    // Method to handle Logout on click of No
    const handleLogout = () => {
        setRevokeToken(false);
        setOpenToken(false);
        const logoutRequest = {
            logoutType: "logout",
            userId: otpResponse.userId ? otpResponse.userId : ''
        }
        logoutDispatch(logoutRequest);
    }
    // Method to redirect to ChangePassword
    const redirectToCP = () => {
        const userName = (loginUserData.firstName ? loginUserData.firstName : '') + ' ' + (loginUserData.lastName ? loginUserData.lastName : '');
        const eventLog = {
            memberId: "",
            createdBy: otpResponse.userId && otpResponse.userId,
            eventSource: "Login",
            eventType: "Login Success",
            eventDescription: `Member ${otpResponse.userId && otpResponse.userId} has successfully logged into the system at ${new Date()}.`
        }
        dispatch(EventsLogActions(eventLog));
        dispatch(resetLogoutData('appConfigDropdown'));
        // captcha.current.reset();
        sessionStorage.setItem('authToken', authToken ? authToken : loginUserData.accessToken);
        props.history.push({
            pathname: '/changePassword',
            state: { userID: otpResponse.userId ? otpResponse.userId : '', source: 'Login', loginTime: new Date(), userName: userName,
            refreshToken: loginUserData.refreshToken, expiresIn: loginUserData.expiresIn }
        });
    }

    // Method to redirect to Claims
    const redirectToClaims = () => {
        const userName = (loginUserData.firstName ? loginUserData.firstName : '') + ' ' + (loginUserData.lastName ? loginUserData.lastName : '');
        const eventLog = {
            memberId: "",
            createdBy: otpResponse.userId && otpResponse.userId,
            eventSource: "Login",
            eventType: "Login Success",
            eventDescription: `Member ${otpResponse.userId && otpResponse.userId} has successfully logged into the system at ${new Date()}.`
        }
        dispatch(EventsLogActions(eventLog));
        dispatch(resetLogoutData('appConfigDropdown'));
        // captcha.current.reset();
        sessionStorage.setItem('authToken', authToken ? authToken : loginUserData.accessToken);
        props.history.push({
            pathname: '/claims',
            state: {
                userID: otpResponse.userId ? otpResponse.userId : '', loginTime: new Date(), userName: userName,
                refreshToken: loginUserData.refreshToken, expiresIn: loginUserData.expiresIn 
                // refreshToken: 'aoapapajaska', expiresIn: 50000
            }
        });
    }

    // method to call backend service to send otp
    const submitOtp = () => {
        setSpinnerLoader(true)
        setErrorMessages([])
        setSuccessMessages([])
        if (!otp) {
            setErrorMessages(['Please enter the authentication token.'])
            setSpinnerLoader(false)
            return
        }
        else if (otp.length < 6) {
            setErrorMessages(['Authentication token must be of 6 digit.'])
            setSpinnerLoader(false)
            return
        }
        else if (!otpResponse){
            setErrorMessages(['Technical Error. Please try after resending the OTP.'])
            setSpinnerLoader(false)
            setOtp('')
            return
        }
        const input = {
            'id': otpResponse && otpResponse.id,
            'verificationCode': otp,
            'memberId': otpResponse && otpResponse.memberId,
            'userId': otpResponse && otpResponse.userId
        }
        // dispatch(ValidateOtpCode(input))

      axios.post(`${serviceEndPoint.VALIDATE_OTP}`, input)
      .then(response => {
        if (response && response.data && response.data.status === 'Success') {
            dispatch(ValidateOtpResponse(response.data));
            setIsValidatedOTP(true);
        }
        else if (response && response.data && response.data.status === 'Failed') {
            dispatch(ValidateOtpCount())
            // setErrorMessages([validateOtpRes.message])
            setErrorMessages(['The verification code you entered is incorrect.'])
            setSpinnerLoader(false)
            setOtp('')
        }
        else if (response && response.data && (response.data.status === 'Technical Error')) {
            setErrorMessages([SYSTEM_ERROR])
            setSpinnerLoader(false)
            setOtp('')
        }
        
      })
      .catch(error => {
        dispatch(ValidateOtpResponse({ systemFailure: true }));
        setIsValidatedOTP(false);
        setErrorMessages([SYSTEM_ERROR])
        setSpinnerLoader(false)
        setOtp('')
      });

        
    }

    const resendOTP = () => {
        setSpinnerLoader(true);
        setSuccessMessages([])
        setErrorMessages([])
        dispatch(ResetOtpCount());
        const input = {'mfaType': mfaType,
        'userId': userIdForResend};

        axios.post(`${serviceEndPoint.GENERATE_OTP}`, input)
        .then(response => {
            dispatch(GenerateOtpResponse(response.data));
            setIsCodeGenerated(true)
            setSpinnerLoader(false);
        })
        .catch(error => {
            dispatch(GenerateOtpResponse({ systemFailure: true }));
            setIsCodeGenerated(false);
            setSpinnerLoader(false);
        });

    }
    return (
        <div className="container">
            {spinnerLoader ? <Spinner /> : null}
            <div className="success-alert-container">
                {errorMessages && errorMessages.length > 0 ?
                    <ErrorMessages errorMessages={errorMessages} /> : null}
                {errorMessages && successMessages && errorMessages.length === 0 && successMessages.length > 0 ?
                    <SuccessMessage successMessages={successMessages} /> : null}
            </div>
            <div className="contact-us-block-success font-weight-600">
                <a href="/contactUs" target="_blank">Contact Us</a>
                <span className="blue-font px-1">|</span>
                <a href="/Help" target="_blank">Help</a>
            </div>
            <div className="success-container">
                <div className="sub-header">Additional Security Verification</div>
                <hr />
                <div className="">
                    {/* <img src="Successfully_submitted.svg" className="mx-auto d-block" alt="Successfully Submitted" />
                    <h6 className="text-center font-weight-bold my-3">Congratulations!</h6>
                    <p className="text-center px-lg-5 pb-0 m-0">You have confirmed email and phone number. Please choose one below to receive a 6-digit code.</p> 
                    <p className="text-center px-lg-5 pt-0 m-0 mb-3">You will receive a confirmation of your registration containing your one-time password via the email 
                        you entered. 
                    </p>
                    <p className="text-center px-lg-5 m-0 mb-5">Please login to continue.</p> */}

                    <fieldset className="custom-fieldset">

                        <div className="form-wrapper col-sm-12 px-2 my-3">
                            <p className="mui-custom-form">We sent 6-digit security code. Please check your inbox and enter the code below. Code will expire
                                after 5 minutes.</p>
                            <div className="mui-custom-form">

                                <TextField
                                    required
                                    id="standard-firstname"
                                    label='Authentication Token'
                                    value={otp}
                                    onChange={handleChanges}
                                    inputProps={{ maxLength: 6 }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    disabled={accountLocked}
                                // error={firstNameError}
                                // helperText={firstNameError ? firstNameErrorText : null}
                                />
                            </div>
                        </div>
                    </fieldset>
                    <div className="button-wrapper">
                     <Button className='btn-primary btn-dialog' onClick={submitOtp} disabled={accountLocked}>
                            Submit </Button>
                    
                    </div>
                    <div className="mui-custom-form my-0 mx-3 mb-2">
                        <p>Haven't received security code yet? <Button size="sm" onClick={resendOTP} disabled={accountLocked}>Resend a new Code</Button></p>
                    </div>
                    <div className="mui-custom-form my-0 mx-3 mb-2">
                    {accountLocked && <a href="/passwordRecovery" className="font-weight-600 mx-1 py-3">Forgot Password/Unlock Account</a>}
                                
                    </div>
                    
                </div>
            </div>
            <>
                <Dialog className='alert-dialog' open={openReminder}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">Your password will expire in {reminderDays} days. Do you want to change now?</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsConfirm" className="btn btn-primary btn-alert mr-2" onClick={redirectToCP}>YES</Button>
                        <Button id="claimsCancel" className="btn btn-transparent btn-alert" onClick={redirectToClaims}>NO</Button>
                    </div>
                </Dialog>

                <Dialog className='alert-dialog' open={openExpired}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">{LoginConstants.PASSWORD_EXPIRED_ERROR}</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsOk" className="btn btn-primary btn-alert mr-2" onClick={redirectToCP}>OK</Button>
                    </div>
                </Dialog>

                <Dialog className='alert-dialog' open={openToken}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">{LoginConstants.PASSWORD_INVALID_TOKEN_ERROR}</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsTokenConfirm" className="btn btn-primary btn-alert mr-2" onClick={handleRevoke}>YES</Button>
                        <Button id="claimsTokenCancel" className="btn btn-transparent btn-alert" onClick={handleLogout}>NO</Button>
                    </div>
                </Dialog>
            </>
            
        </div>
    )
}

export default ValidateOtp